
import { computed, defineComponent, PropType } from "vue";
import { getOfferDisplayTypeFromCheckoutOrderDiscount } from "JS/checkout/utilities/promos";
import { ICheckoutOrderDiscountResource } from "JS/types/Checkout";

import PromoOfferDiscountLine from 'Src/js/components/order/PromoOfferDiscountLine.vue';

export default defineComponent({
	name: "WorkOrderPromoOfferDiscountline",
	components: {
		PromoOfferDiscountLine,
	},
	props: {
		discount: { type: Object as PropType<ICheckoutOrderDiscountResource> },
		amount: String,
		amountHidden: Boolean
	},
	setup(props) {

		const offerType = computed(() => getOfferDisplayTypeFromCheckoutOrderDiscount(props.discount));

		return {
			offerType
		};
	}
});
